import type { AssetId } from '../schema';

export default function isLocalAssetId(assetId: AssetId): boolean {
    return assetId[0] === ':';
}
